module.exports = __webpack_public_path__ + "static/media/study 201105.cc6bcc50.png";